export default __webpack_public_path__ + "static/media/destination 1.a32f13f8.svg";